import { Controller } from "stimulus"

export default class extends Controller {
  visitUrl() {
    Turbolinks.visit(event.currentTarget.dataset.url)
  }
}